import { PropsWithClassName } from "@/shared/types/utils";
import { PropsWithChildren } from "react";
import { cn } from "@/shared/utils";

export const Box = (props: PropsWithClassName<PropsWithChildren>) => (
  <div
    className={cn(
      "bg-white/5 border border-white/20 rounded-3xl",
      props.className
    )}
  >
    {props.children}
  </div>
);
